import React from 'react';
import { whatIBringData } from '../../data/whatIBringData';
import './WhatIBring.css';

const WhatIBring = () => {
  // SVG图标组件数组
  const svgIcons = [
    () => <img src="/images/svg/1.png" alt="icon" className="svg-icon" />,
    () => <img src="/images/svg/2.png" alt="icon" className="svg-icon" />,
    () => <img src="/images/svg/3.png" alt="icon" className="svg-icon" />
  ];

  const handleContactClick = () => {
    // 滚动到页面底部的联系方式或Footer
    const footer = document.getElementById('footer') || document.querySelector('footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="what-i-bring-section" id="what-i-bring">
      <div className="what-i-bring-container">
        {/* Header Section */}
        <div className="what-i-bring-header">
          <div className="what-i-bring-label">My Expertise</div>
          <h2 className="what-i-bring-title">
            Where Business Meets<br />
            Technology
          </h2>
        </div>
        
        {/* Cards Grid */}
        <div className="what-i-bring-cards">
          {whatIBringData.map((item, index) => {
            const IconComponent = svgIcons[index];
            return (
              <div key={index} className="what-i-bring-card">
                <div className="card-icon-wrapper">
                  <IconComponent />
                </div>
                <h3 className="card-title">{item.title}</h3>
                <p className="card-description">{item.description}</p>
              </div>
            );
          })}
        </div>

        {/* Contact Button */}
        <div className="contact-button-container">
          <button className="contact-button" onClick={handleContactClick}>
            Getting in Touch with me
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhatIBring;